'use strict';

const Events = require('constants/Events');
const Constants = require('constants/Constants');

const Page = require('pages/Page/Page.js');

require('./PagePlatform.less');

const PlatformHero = require('components/Platform/PlatformHero/PlatformHero');
const PlatformProduct = require('components/Platform/PlatformProduct/PlatformProduct');
const PlatformCardExperience = require('components/Platform/PlatformCardExperience/PlatformCardExperience');

require('components/Platform/PlatformWhatMakesDifferent/PlatformWhatMakesDifferent');
require('components/Platform/PlatformLaunch/PlatformLaunch');

const ChildViews = {
    'PlatformHero': {
        selector: '.PlatformHero',
        viewConstructor: PlatformHero
    },
    'PlatformProduct': {
        selector: '.PlatformProduct',
        viewConstructor: PlatformProduct
    },
    'PlatformCardExperience': {
        selector: '.PlatformCardExperience',
        viewConstructor: PlatformCardExperience
    }
};

module.exports = Page.extend({

    events: {},

    initialize: function (options = {}) {
        Page.prototype.initialize.call(this, options);

        // this setTimeout imitated loading page
        setTimeout(() => {
            app.vent.trigger(Events.home.hero.cardLoaded);
            app.vent.trigger(Events.home.hero.videoSequenceLoaded);
            app.vent.trigger(Events.common.pageLoaded);
            app.els.$body.removeClass(Constants.cssClasses.isInitialState);
        }, 1000);

        this.viewsRegistration(ChildViews);
    }
});
